<div class="flex items-center h-[100vh] overflow-hidden">
  <!-- Left Section with Image -->
  <div class="hidden text-center md:w-1/2 md:flex">
    <img
      src="/images/login.png"
      alt="Login Image"
      class="object-cover w-full h-full" />
  </div>

  <!-- Right Section with Form -->
  <p-blockui [target]="pnl" [blocked]="blockedPanel" />
  <div #pnl class="w-[100%] md:w-1/2 flex justify-center items-center h-[100vh]">
    <div class="block w-[90%] md:w-[75%] mx-auto">
      <h2 class="text-center text-[30px] md:text-[40px] font-[35px] font-sans">
        Cladded Glass Broadband
      </h2>
      <h3 class="text-center text-[20px] md:text-[30px] mb-5">
        Create your Account
      </h3>
      <div class="mb-3 p-field">
        <label for="email" class="mb-1">Email</label>
        <input
          class="p-3 text-black bg-white rounded-lg hover:bg-medium_blue-900"
          id="email"
          type="email"
          pInputText
          [(ngModel)]="email"
          placeholder="Enter your email" />
      </div>

      <!-- Password Field -->
      <div class="mb-4 p-field">
        <label for="password">Password</label>
        <input
          class="p-3 text-black bg-white rounded-lg hover:bg-medium_blue-900"
          id="password"
          type="password"
          pInputText
          [(ngModel)]="password"
          placeholder="Enter your password" />
      </div>

      <!-- Password Field -->
      <div class="mb-4 p-field">
        <label for="password">Confirm Password</label>
        <input
          (blur)="checkPasswords()"
          class="p-3 text-black bg-white rounded-lg hover:bg-medium_blue-900"
          id="confirmPassword"
          type="password"
          pInputText
          [(ngModel)]="confirmPassword"
          placeholder="Enter your password" />
      </div>
      <div class="mb-4 p-field" *ngIf="passwordMismatch">
        <span class="content-center w-full text-red-500">
          Passwords do not match!!
        </span>
      </div>

      <!-- Login Button -->
      <div class="flex items-center justify-start mb-4 space-x-5">
        <button
          [disabled]="passwordMismatch"
          pButton
          class="p-3 shadow-xs bg-primary-500 hover:bg-medium_blue-800 min-w-48"
          label="Register"
          (click)="register()"></button>
        <span class="p-3 font-semibold">OR</span>
        <button
          [disabled]="passwordMismatch"
          pButton
          class="p-3 min-w-48 hover:bg-medium_blue-800"
          (click)="loginWithGoogle()"
          style="color: #000">
          <img src="/icons/google.png" alt="" class="w-[20px]" />
          Register with Google
        </button>
      </div>
      <div class="py-3 text-center account-switch">
        <p>
          Already have an account?
          <a routerLink="/login" class="switch-link">Sign in instead</a>
        </p>
      </div>
    </div>
  </div>
</div>
